/* js/logout.js */

;(function($, window, document) {

    $(document).ready(function () {

        if (typeof userClick === 'function') {
            userClick();
        }

    });


    // userClick function
    function userClick() {
        $('#social .user-logout-button').on('mouseenter, mouseover', function (e) {
            $(this).find($('.level_2')).addClass('open');
            $(this).find($('nav')).addClass('open');
        });
        $('#social .user-logout-button').on('mouseleave', function (e) {
             $(this).find($('.level_2')).removeClass('open');
             $(this).find($('nav')).removeClass('open');
        });
    }

})(jQuery, window, document);
